module.exports = __webpack_public_path__ + "img/yxfwkhzs.c3f260ee.png";